import React from 'react';
import './sideBar.css';
import { Link, useLocation } from 'react-router-dom';

function SideBar() {
  const location = useLocation();
  console.log(location.pathname);
  return (
    // menggunakan komponen boostrap
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        <li className="nav-item">
          <Link className="nav-link" to="/">
            <i className="bi bi-grid"></i>
            <span>Dashboard</span>
          </Link>
        </li>
        <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-bs-target="#components-nav"
            data-bs-toggle="collapse"
            href="master data"
          >
            <i className="bi bi-menu-button-wide"></i>
            <span>Master Data</span>
            <i className="bi bi-chevron-down ms-auto"></i>
          </a>
          <ul
            id="components-nav"
            className="nav-content collapse"
            data-bs-parent="#sidebar-nav"
          >
            <li>
              <Link to="account">
                <i className="bi bi-circle"></i>
                <span>Account</span>
              </Link>
            </li>
            <li>
              <Link to="internal">
                <i className="bi bi-circle"></i>
                <span>Internal</span>
              </Link>
            </li>
            <li>
              <Link to="external">
                <i className="bi bi-circle"></i>
                <span>External</span>
              </Link>
            </li>
            <li>
              <Link to="project">
                <i className="bi bi-circle"></i>
                <span>Project</span>
              </Link>
            </li>
            <li>
              <Link to="business-unit">
                <i className="bi bi-circle"></i>
                <span>Business Unit</span>
              </Link>
            </li>
            {/* <li>
              <Link to="new-transaction">
                <i className="bi bi-circle"></i>
                <span>New Menu</span>
              </Link>
            </li> */}
            <li>
              <Link to="project-cost">
                <i className="bi bi-circle"></i>
                <span>Budgeting Project Code</span>
              </Link>
            </li>
          </ul>
        </li>
        <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-bs-target="#transaction-nav"
            data-bs-toggle="collapse"
            href="transaction"
          >
            <i className="bi bi-cash-coin"></i>
            <span>Transaction</span>
            <i className="bi bi-chevron-down ms-auto"></i>
          </a>
          <ul
            id="transaction-nav"
            className="nav-content collapse"
            data-bs-parent="#sidebar-nav"
          >
            <li>
              <Link to="project-transaction">
                <i className="bi bi-circle"></i>
                <span>Project Transaction</span>
              </Link>
            </li>
            <li>
              <Link to="temporary-transaction">
                <i className="bi bi-circle"></i>
                <span>Temporary Transaction</span>
              </Link>
            </li>
            <li>
              <Link to="daily-transaction">
                <i className="bi bi-circle"></i>
                <span>Daily Transaction</span>
              </Link>
            </li>
            <li>
              <Link to="opening-balance">
                <i className="bi bi-circle"></i>
                <span>Opening Balance</span>
              </Link>
            </li>
            <li>
              <Link to="project-cost-transaction">
                <i className="bi bi-circle"></i>
                <span>Poject Budgeting</span>
              </Link>
            </li>
          </ul>
        </li>
        <li className="nav-item">
          <Link
            className={`nav-link ${
              location.pathname.startsWith('/inquiry') ? '' : 'collapsed'
            }`}
            to="inquiry"
          >
            <i className="bi bi-clipboard-data"></i>
            <span>Inquiry</span>
          </Link>
        </li>
        <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-bs-target="#report-nav"
            data-bs-toggle="collapse"
            href="report"
          >
            <i className="bi bi-file-earmark-text"></i>
            <span>Report</span>
            <i className="bi bi-chevron-down ms-auto"></i>
          </a>
          <ul
            id="report-nav"
            className="nav-content collapse"
            data-bs-parent="#sidebar-nav"
          >
            <li>
              <Link to="coa-report">
                <i className="bi bi-circle"></i>
                <span>Chart Of Account</span>
              </Link>
            </li>
            {/* <li>
              <Link to="lala">
                <i className="bi bi-circle"></i>
                <span>General Journal</span>
              </Link>
            </li>
            <li>
              <Link to="lala">
                <i className="bi bi-circle"></i>
                <span>Costumer</span>
              </Link>
            </li>
            <li>
              <Link to="lala">
                <i className="bi bi-circle"></i>
                <span>Daily Transaction</span>
              </Link>
            </li> */}
          </ul>
        </li>
        <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-bs-target="#utility-nav"
            data-bs-toggle="collapse"
            href="utility"
          >
            <i className="bi bi-tools"></i>
            <span>Administration</span>
            <i className="bi bi-chevron-down ms-auto"></i>
          </a>
          <ul
            id="utility-nav"
            className="nav-content collapse"
            data-bs-parent="#sidebar-nav"
          >
            <li>
              <Link to="users">
                <i className="bi bi-circle"></i>
                <span>Users</span>
              </Link>
            </li>
          </ul>
        </li>
      </ul>
    </aside>
  );
}

export default SideBar;
